module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small-6 cell image-cells"
  }, [_c('a', {
    attrs: {
      "href": _vm.dataSourceFull,
      "data-lightbox": "image-1"
    }
  }, [_c('div', {
    staticClass: "img-container",
    style: ({
      'background': 'url(' + _vm.dataSource + ')'
    })
  })]), _vm._v(" "), _c('span', {
    staticClass: "remove-image",
    attrs: {
      "aria-hidden": "true",
      "data-open": 'removeImageModal' + _vm.upload.id
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "reveal",
    attrs: {
      "id": 'removeImageModal' + _vm.upload.id,
      "data-reveal": ""
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("Du er ved at slette et billede")]), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "img-center",
    attrs: {
      "src": _vm.dataSource,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "spacing"
  }), _vm._v(" "), _c('div', {
    staticClass: "grid-x"
  }, [_c('div', {
    staticClass: "small-6 cell",
    staticStyle: {
      "padding-right": "4px"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "data-close": 'removeImageModal' + _vm.upload.id
    }
  }, [_vm._v("Annuller")])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 cell",
    staticStyle: {
      "padding-left": "4px"
    }
  }, [_c('button', {
    staticClass: "button call-to-action",
    attrs: {
      "data-close": 'removeImageModal' + _vm.upload.id
    },
    on: {
      "click": function($event) {
        return _vm.removeUpload(_vm.upload.id)
      }
    }
  }, [_vm._v("Slet")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_c('b', [_vm._v("Er du sikker?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-674d82ba","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormUpload.vue
// module id = 1011
// module chunks = 1